import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=54af5b3e&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=54af5b3e&prod&scoped=true&lang=css"
import style1 from "./ContentFooter.vue?vue&type=style&index=1&id=54af5b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af5b3e",
  null
  
)

export default component.exports